module.exports = __webpack_public_path__ + "img/folgory.b3d6b9a1.png";